const getFullShopName = (shopId: string, shops: IMerchant[]): string => {
  const shop = shops.find((shopRow) => shopRow.id === shopId);
  return shop!.platform ? `${shop!.name} (Platform)` : shop!.name;
}

export default getFullShopName;
